import { useCallback, useState } from "react";

import { getNextSaturday, getPreviousSunday } from "@utils/general";
import FlowbiteDatepickerInLine from "@components/DatepickerInLine";
import  Button  from "@components/Button";
import Spinner from "@components/Spinner";
import { format } from "date-fns";
import { generatePaystub } from "@service/paystubApiService";

export function PayStub(): JSX.Element {
  const [start_date, setStartDate] = useState<Date | null>(getPreviousSunday(null,-1));
  const [end_date, setEndDate] = useState<Date | null>(getNextSaturday(new Date(),-1));
  const [payStubGenerator, setPayStubGenerator] = useState<boolean>(false);
  const [sendingPaystub, setSendingPaystub] = useState<boolean>(false);

  function handleStartDateChange(date: Date) {
    if(date.getDay() !== 0) {
      alert("Please select a Sunday.");
      return;
    }
    setStartDate(date);
    const nextSaturday = (getNextSaturday(date? date : new Date()));
    setEndDate(nextSaturday);
  }

  function handleEndDateChange(date: Date | null) {
    if(!date) {
      setEndDate(null);
      return;
    }
    if(date.getDay() !== 6) {
      alert("Please select a Saturday.");
      return;
    }
    const previousSunday = getPreviousSunday(date);
    handleStartDateChange(previousSunday);
  }


  async function handleSubmitPayStub() {
    try {
      if(!start_date || !end_date) {
        alert("Please select a valid start and end date.");
        return;
      }
      setSendingPaystub(true);
      setPayStubGenerator(false);
      const sendData = {
        start_date: format(start_date, "yyyy-MM-dd"),
        end_date: format(end_date, "yyyy-MM-dd"),
      }
      await generatePaystub(sendData);
      setSendingPaystub(false);
      alert("Paystub successfully generated!");

    } catch (err) {
      setSendingPaystub(false);
      console.error("Paystub error:", err);
      alert(`Paystub failed. ${err}`);
    }
  }

  const handlePayStubGenerator = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setPayStubGenerator(true);
    } else {
      setPayStubGenerator(false);
    }
  }, []);

  return (
    <>
      <div className="tw-flex tw-mb-2 tw-h-[42vh]">
        <div className="tw-flex tw-min-w-[380px] tw-flex-col">
          <h4 className="Subheader tw-mb-3">Paystub Generator</h4>
          <div className="tw-flex tw-flex-row tw-items-center tw-mb-3 tw-ml-4 tw-mt-4">
            <span className="tw-w-8">Start:</span>
            <FlowbiteDatepickerInLine 
              name={undefined} 
              value={start_date} 
              handleOnChange={handleStartDateChange} 
              handleOnBlur={undefined} 
              className="tw-w-[350px] tw-ml-2" 
              />
          </div>
          <div className="tw-flex tw-flex-row tw-items-center tw-mb-3 tw-ml-4">
            <span className="tw-w-8">End:</span>
            <FlowbiteDatepickerInLine 
              name={undefined} 
              value={end_date} 
              handleOnChange={handleEndDateChange} 
              handleOnBlur={undefined} 
              className="tw-w-[350px] tw-ml-2" 
            />
          </div>
          <div className="tw-flex tw-justify-left tw-mt-6 tw-ml-5 tw-items-center">
            <input checked={payStubGenerator} type="checkbox" className="tw-flex tw-flex-row" id="add-pay-stub" name="add_pay_stub" onChange={handlePayStubGenerator} />
            <span className="tw-ml-5 tw-text-red-600 ">Thursday Button!</span>
            <span className="tw-ml-1">ONLY SELECT WHEN PAY IS 100% CORRECT!!!</span>
          </div>
          <div className="tw-flex tw-justify-center tw-mt-5 tw-ml-14">
            <Button
                className="md:tw-w-[50%]"
                onClick={handleSubmitPayStub}
                disabled={!payStubGenerator}
                >
                {sendingPaystub ? <Spinner className="tw-flex tw-justify-center tw-ml-2 tw-items-center" /> : 'Generate Paystub'}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}